var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "funding-details-link d-flex align-items-center justify-content-end",
    },
    [
      _c("ob1-liens-icone", {
        attrs: {
          mini: "",
          "is-button": "",
          icon: "icon-info-alt",
          title: _vm.text,
        },
        on: {
          click: function ($event) {
            return _vm.$emit("fundingDetailsClick", _vm.versionSeoId)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }